var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.nuances && _vm.nuances.length)?_c('div',{staticClass:"nuance-badges"},_vm._l((_vm.nuances),function(n){return _c('span',{key:n.code,staticClass:"badge-item",style:({ backgroundColor: n.color }),attrs:{"title":n.detail}},[_vm._v("\n    "+_vm._s(n.label)+"\n  ")])}),0):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0480495d","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/pages/components/layouts/companyNuanceBadges.vue
// module id = 942
// module chunks = 0